import { render } from "./prixTemplate.vue?vue&type=template&id=485ebba1&scoped=true"
import script from "./prixTemplate.vue?vue&type=script&lang=js"
export * from "./prixTemplate.vue?vue&type=script&lang=js"

import "./prixTemplate.vue?vue&type=style&index=0&id=485ebba1&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485ebba1"]])

export default __exports__